import { useAtom } from "jotai";
import { useHydrateAtoms } from "jotai/utils";
import type { PaymentPeriod } from "../../components/QuoteCards/types";
import { ANNUAL } from "../../constants/constants";
import { paymentToggleAtom } from "../../store";

/**
 * This hook is used to set the payment period global state on
 * the server side.  State is then persisted in the client.
 */
export const useSetPaymentToggleAtom = (
  paymentPeriod: PaymentPeriod = ANNUAL,
) => {
  useHydrateAtoms([[paymentToggleAtom, paymentPeriod]]);
};

export const usePaymentToggleState = () => useAtom(paymentToggleAtom);
